module.exports = __webpack_public_path__ + "img/middlecontrolhoz.a29cfa1e.svg";